import React from 'react';
import PropTypes from 'prop-types';

const FileUploaderPreview = ({ file, policy, signature }) => {
    if (!file || !file.mimetype) {
        return null;
    }
    const url = file.previewUrl || file.url;
    if (file.mimetype.startsWith('image')) {
        return <img src={url} alt={file.filename} />;
    } else if (file.mimetype.startsWith('video')) {
        return <video controls src={url}>No Video</video>;
    } else if (file.mimetype.startsWith('audio')) {
        return <audio controls src={url}>No Audio</audio>;
    } else {
        return(
            <iframe
                title={file.filename}
                src={`https://www.fs.app.getsynapse.com/preview/security=p:${policy},s:${signature}/${file.handle}`}
                frameBorder="0"
            />
        );
    }
};

FileUploaderPreview.propTypes = {
    file: PropTypes.object.isRequired,
    policy: PropTypes.string.isRequired,
    signature: PropTypes.string.isRequired,
};

export default FileUploaderPreview;
